import React from 'react'

import PrintBarCode from './PrintBarCode/PrintBarCode'
import styles from '../styles/components/panel.module.scss'
import { useSocPublicImageBucketUrl } from 'src/hooks/useSocPublicImageBucketUrl'

type PostCardSleeveProps = {}
const PostCardSleeve: React.FC<PostCardSleeveProps> = props => {
  const sleeveImage = useSocPublicImageBucketUrl('postcard-sleeve')
  return (
    <div className={styles.postCardSleeve}>
      <div className={styles.stamp}>
        <img className="img-responsive" src={sleeveImage} alt="" />
      </div>
      <div className={styles.sleeveReturnAddress}>
        <p>Return Address</p>
        <p>Will Print Here</p>
      </div>
      <div className={styles.sleeveToAddress}>
        <p>Recipient Address</p>
        <p>Will Print Here</p>
      </div>
      <div className={styles.bottomRightBarCode}>
        <PrintBarCode size={20} />
      </div>
    </div>
  )
}
export default PostCardSleeve
